var map = {
	"./angiang.png": 6548,
	"./baclieu.png": 492,
	"./bentre.png": 6485,
	"./binhdinh.png": 1662,
	"./binhduong.png": 5955,
	"./binhphuoc.png": 7200,
	"./binhthuan.png": 2751,
	"./camau.png": 6221,
	"./cantho.png": 8612,
	"./daklak.png": 4803,
	"./daknong.png": 951,
	"./dalat.png": 247,
	"./danang.png": 8590,
	"./dongnai.png": 1951,
	"./dongthap.png": 562,
	"./gialai.png": 5891,
	"./haugiang.png": 1835,
	"./hue.png": 7041,
	"./khanhhoa.png": 4507,
	"./kiengiang.png": 1815,
	"./komtum.png": 9991,
	"./longan.png": 2861,
	"./mienbac.png": 6410,
	"./ninhthuan.png": 604,
	"./phuyen.png": 346,
	"./quangbinh.png": 6208,
	"./quangnam.png": 2804,
	"./quangngai.png": 4177,
	"./quangtri.png": 1071,
	"./soctrang.png": 3277,
	"./tayninh.png": 3202,
	"./tiengiang.png": 6632,
	"./tphcm.png": 2716,
	"./travinh.png": 6254,
	"./vinhlong.png": 133,
	"./vungtau.png": 1265
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5322;